import React from 'react';
import './PreventionPage.css';

import { Heading, PageTitle, Prevention } from '../../../components';
import { preventions } from '../../../constants';



const PreventionPage = () => {
  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Fire Preventions'} page={'Fire Preventions'} />

      {/* Fire Preventions Section */}
      <section className='preventions'>

        {/* Section heading */}
        <Heading title={'Fire Prevention Tips'} subTitle={'Excellence in Fire Prevention'} />

        <div className='box-container'>

          {/* Map over the preventions array to render each prevention */}
          {preventions.map((prev) => { 
            return (
              <Prevention key={prev.id} prev={prev} />
            );
          })}

        </div>

      </section>

    </>
  );
}

export default PreventionPage;